import { CardSheet } from '@/components/BillingPage/CardEntry/CardSheet'
import { analytics } from '@/lib/analytics'
import { Button, ButtonText } from '@/ui/core/button'
import { useState } from 'react'
import Toast from 'react-native-toast-message'

/**
 * The card form in a sheet, like every other form in the app. The button that opens it is the
 * row's own trailing action: Update when a card is on file, Add when not.
 */
const UpdateCardModal = ({
	label = 'Update',
	tone = 'ink',
}: { label?: string; tone?: 'ink' | 'white' }) => {
	const [open, setOpen] = useState(false)

	const onComplete = () => {
		analytics.trackEvent('updated-billing-info')
		setOpen(false)
		Toast.show({ type: 'success', text1: 'Card updated' })
	}

	return (
		<>
			<Button
				variant={tone === 'white' ? 'ghost' : 'secondary'}
				size="sm"
				fullWidth={false}
				onPress={() => setOpen(true)}
			>
				<ButtonText>{label}</ButtonText>
			</Button>
			<CardSheet open={open} onClose={() => setOpen(false)} onSaved={onComplete} />
		</>
	)
}

export { UpdateCardModal }
